import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconPhone } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { usePhoneNumber } from '../../../../../../components/hooks/usePhoneNumber.js';
import { Phone } from '../../../../../../components/internal/Phone.js';
import { Container } from '../../../../../../components/SearchForm/components/TravellersWidget/components/HotlineWidget/components/Container.js';
import { Heading } from '../../../../../../components/SearchForm/components/TravellersWidget/components/HotlineWidget/components/Heading.js';
import { Subheading } from '../../../../../../components/SearchForm/components/TravellersWidget/components/HotlineWidget/components/Subheading.js';
import { LabelXSmall, Stack } from '../../../../../../primitives/index.js';
export const HotlineWidget = ({
  config,
  embedded
}) => {
  const {
    t
  } = useTranslation();
  const phone = usePhoneNumber(config);
  return _jsxs(Container, {
    justifyContent: "center",
    alignItems: "center",
    spacing: "medium",
    embedded: Boolean(embedded),
    children: [_jsx(Heading, {
      color: "contentPrimary",
      children: t('travellersWidget:multiRoomBooking.heading')
    }), _jsxs(Stack, {
      spacing: "xSmall",
      alignItems: embedded ? 'normal' : 'center',
      children: [_jsx(Subheading, {
        color: "contentPrimary",
        children: t('travellersWidget:multiRoomBooking.subHeading')
      }), _jsxs(Phone, {
        href: `tel:${phone}`,
        children: [_jsx(IconPhone, {}), " ", phone]
      }), _jsx(LabelXSmall, {
        color: "contentSecondary",
        children: t('travellersWidget:multiRoomBooking.workingHours', {
          openingHours: '09:00 – 22:00'
        })
      })]
    })]
  });
};